/**
 * Zentraler, einheitlicher Scan-Button für die gesamte App.
 * Einheitliches Aussehen: gleiche Größe, Farbe, Icon, Padding auf allen Seiten.
 */
import React from 'react';
import { Button } from '@/components/ui/button';
import { QrCode } from 'lucide-react';

/**
 * @param {Object} props
 * @param {Function} props.onClick - Click-Handler
 * @param {string} [props.className] - Zusätzliche CSS-Klassen
 * @param {boolean} [props.disabled] - Button deaktivieren
 * @param {string} [props.label] - Button-Text (default: "Scannen")
 * @param {string} [props.size] - Button-Größe: 'sm', 'default', 'lg' (default: 'default')
 * @param {string} [props.variant] - Button-Variante: 'default', 'outline' (default: 'default')
 */
const ScanButton = ({ 
  onClick, 
  className = '', 
  disabled = false, 
  label = 'Scannen',
  size = 'default',
  variant = 'default',
  ...props 
}) => {
  // Einheitliches Styling für alle Scan-Buttons
  const baseClasses = variant === 'default' 
    ? 'bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white shadow-lg'
    : '';
  
  const sizeClasses = {
    sm: 'px-3 py-2 text-sm',
    default: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg'
  };

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      className={`flex items-center space-x-2 ${baseClasses} ${sizeClasses[size]} ${className}`}
      data-testid="scan-button"
      {...props}
    >
      <QrCode size={size === 'lg' ? 24 : size === 'sm' ? 16 : 20} />
      <span>{label}</span>
    </Button>
  );
};

export default ScanButton;
